module.exports = __webpack_public_path__ + "img/up-concave-dark.31f154bd.svg";